import { Box, useColorModeValue } from "@chakra-ui/react";
import { useSessionTimeout } from "app/providers/session-timeout-provider";
import type React from "react";
import SessionWarningModal from "views/components/session-warning-modal";
import DashboardContent from "./content";
import Sidebar from "./sidebar";

const DashboardLayout = (): JSX.Element => {
  const { isWarningActive } = useSessionTimeout();

  return (
    <Layout>
      <Sidebar />
      <DashboardContent />
      <SessionWarningModal
        isOpen={isWarningActive}
        onClose={() => {}} // Controlled by the session timeout service
      />
    </Layout>
  );
};

type LayoutProps = { children: React.ReactNode };

const Layout = (props: LayoutProps) => {
  const bg = useColorModeValue("gray.50", "gray.900");
  
  return (
    <Box display="flex" height="100vh" overflow="hidden" bg={bg}>
      {props.children}
    </Box>
  );
};

export default DashboardLayout;
